import { defineStore } from 'pinia';
export const useBoxBuilderStore = defineStore('boxBuilder', {
    state: () => ({
        selectedBlockId: null,
    }),
    actions: {
        setSelectedBlockId(blockId) {
            this.selectedBlockId = blockId;
        },
    },
    // persist: {
    //     enabled: true,
    // },
});
